// extracted by mini-css-extract-plugin
export var changeIcon = "_56-4";
export var container = "_56-0";
export var divider = "_56-7";
export var externalLinkIcon = "_56-1";
export var green = "_56-5";
export var helpCircleIcon = "_56-3";
export var iconButton = "_56-2";
export var red = "_56-6";